import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "science_body"
};
const _hoisted_2 = {
  class: "science_body_nr"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "tabLists"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "top_info"
};
const _hoisted_7 = {
  class: "img_info info_dom"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  style: {
    "text-indent": "32px",
    "display": "inline-block"
  }
};
const _hoisted_10 = {
  class: "info_dom",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between"
  }
};
const _hoisted_11 = ["onMouseenter", "onClick"];
const _hoisted_12 = {
  style: {
    "text-indent": "32px",
    "display": "inline-block"
  }
};
const _hoisted_13 = {
  class: "learn-more-box"
};
const _hoisted_14 = {
  class: "vido_list"
};
const _hoisted_15 = {
  class: "vido_list_l"
};
const _hoisted_16 = {
  class: "list"
};
const _hoisted_17 = {
  class: "vido_dom"
};
const _hoisted_18 = {
  class: "dome_img"
};
const _hoisted_19 = ["src", "onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 0,
  class: "vido_dom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("h1", null, "口腔健康科普以及术后注意事项", -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index,
      style: _normalizeStyle('color:' + ($setup.tabIndex == index ? '#23A5C8;' : '#000;')),
      onClick: $event => $setup.tabClick(index)
    }, _toDisplayString(item.name), 13, _hoisted_5);
  }), 128))]), $setup.get_data.top?.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: $setup.get_data.top[$setup.select_index].imgUrl,
    alt: ""
  }, null, 8, _hoisted_8), _createElementVNode("div", {
    class: "info_option",
    style: _normalizeStyle('color:' + ($setup.select_index == 0 ? '#16A1C3;' : '#000;') + 'border-bottom:5px solid ' + ($setup.select_index == 0 ? '#16A1C3;' : '#DBF2F3;')),
    onMouseenter: _cache[0] || (_cache[0] = $event => $setup.info_option(0)),
    onClick: _cache[1] || (_cache[1] = $event => $setup.details($setup.get_data.top[0].id, 0))
  }, [_createElementVNode("h3", null, _toDisplayString($setup.get_data.top[0].title), 1), _createElementVNode("span", _hoisted_9, _toDisplayString($setup.get_data.top[0].brief), 1)], 36)]), _createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    style: {
      "width": "80px",
      "background": "#12A4C0",
      "height": "10px"
    }
  }, null, -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
    return _createElementVNode("div", {
      class: "info_option",
      style: _normalizeStyle('color:' + ($setup.select_index == index + 1 ? '#16A1C3;' : '#000;') + 'border-bottom:5px solid ' + ($setup.select_index == index + 1 ? '#16A1C3;' : '#DBF2F3;')),
      onMouseenter: $event => $setup.info_option(index + 1),
      onClick: $event => $setup.details($setup.get_data.top[index + 1].id, 0)
    }, [_createElementVNode("h3", null, _toDisplayString($setup.get_data.top[index + 1].title), 1), _createElementVNode("span", _hoisted_12, _toDisplayString($setup.get_data.top[index + 1].brief), 1)], 44, _hoisted_11);
  }), 64))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: "learn-more",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.more && $setup.more(...args))
  }, "了解更多")]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("h2", null, _toDisplayString($setup.tabList[$setup.tabIndex].name) + "注意事项", 1), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.boot, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
      src: item.imgUrl,
      onClick: $event => $setup.details(item.id, index)
    }, null, 8, _hoisted_19), _createElementVNode("div", null, [_createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = (...args) => $setup.call && $setup.call(...args)),
      style: {
        "font-size": "15px"
      }
    }, "联系我们"), _createElementVNode("span", {
      onClick: $event => $setup.details(item.id, index),
      style: {
        "font-size": "15px"
      }
    }, "术后指引", 8, _hoisted_20)])])]);
  }), 256)), $setup.get_data.boot && $setup.get_data.boot.length % 3 == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_21)) : _createCommentVNode("", true)])])])])])]);
}